// The University of Manitoba's faculties, colleges and schools.
//
// ⚠️ MIRRORS UMapsMobile's `src/onboarding/profile.ts` (`FACULTIES`). That list
// is what a student picks in the app's onboarding questionnaire, and the ids
// here are what an event's faculty restriction is matched against — so an id
// that exists in one repo and not the other is an event shown to NOBODY, which
// looks exactly like an event nobody came to. `api/_eventStore.js` holds the
// ids a third time (it cannot import this file: ESM in the client bundle) and
// `api/events.test.cjs` pins the two halves of this repo together.
//
// Ordered by subject, not by first letter — the same order the app uses, and
// the only one a reader experiences as alphabetical. Sorting the LABELS files
// Engineering under P for "Price" and puts nine consecutive "Faculty of…" rows
// in the middle of the list; nobody scans for "Price".
//
// `short` is the word that distinguishes each one. It is what the list is
// ordered by, and it is also what gets printed: a chip in the creator and a
// badge on an event are both places where "Clayton H. Riddell Faculty of
// Environment, Earth, and Resources" is a paragraph. The full label is still
// carried on the chip's `title`, because a club matching this against the name
// on a letter needs the real thing.

export const FACULTIES = [
  { id: 'agriculture', short: 'Agricultural', label: 'Faculty of Agricultural and Food Sciences' },
  { id: 'architecture', short: 'Architecture', label: 'Faculty of Architecture' },
  { id: 'art', short: 'Art', label: 'School of Art' },
  { id: 'arts', short: 'Arts', label: 'Faculty of Arts' },
  { id: 'business', short: 'Business', label: 'I. H. Asper School of Business' },
  { id: 'dentistry', short: 'Dentistry', label: 'Dr. Gerald Niznick College of Dentistry' },
  { id: 'education', short: 'Education', label: 'Faculty of Education' },
  { id: 'engineering', short: 'Engineering', label: 'Price Faculty of Engineering' },
  { id: 'environment', short: 'Environment', label: 'Clayton H. Riddell Faculty of Environment, Earth, and Resources' },
  { id: 'extended', short: 'Extended Education', label: 'Extended Education' },
  { id: 'graduate', short: 'Graduate Studies', label: 'Faculty of Graduate Studies' },
  { id: 'kinesiology', short: 'Kinesiology', label: 'Faculty of Kinesiology and Recreation Management' },
  { id: 'law', short: 'Law', label: 'Faculty of Law' },
  { id: 'medicine', short: 'Medicine', label: 'Max Rady College of Medicine' },
  { id: 'music', short: 'Music', label: 'Desautels Faculty of Music' },
  { id: 'nursing', short: 'Nursing', label: 'College of Nursing' },
  { id: 'pharmacy', short: 'Pharmacy', label: 'College of Pharmacy' },
  { id: 'rehab', short: 'Rehabilitation Sciences', label: 'College of Rehabilitation Sciences' },
  { id: 'science', short: 'Science', label: 'Faculty of Science' },
  { id: 'social-work', short: 'Social Work', label: 'Faculty of Social Work' },
  { id: 'u1', short: 'University 1', label: 'University 1' },
];

const BY_ID = new Map(FACULTIES.map(f => [f.id, f]));

/** Every id this build knows. An unknown one is dropped rather than printed. */
export const isFaculty = (id) => BY_ID.has(id);

/** "Price Faculty of Engineering" — the real name, for a form. */
export const facultyLabel = (id) => BY_ID.get(id)?.label || '';

/** "Engineering" — the distinguishing word, for a chip or a badge. */
export const facultyShort = (id) => BY_ID.get(id)?.short || '';
